// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2wLlk","content":"styles_content__2I9sq","checkbox":"styles_checkbox__36F7Z","checkboxLabel":"styles_checkboxLabel__3wKEF"};